import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailMarketing = (props) => /* @__PURE__ */ _jsxs("svg", {
	name: "mailchimp",
	viewBox: "0 0 298 90",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("filter", {
		x: "-1.1%",
		y: "-4.7%",
		width: "102.1%",
		height: "109.4%",
		filterUnits: "objectBoundingBox",
		id: "a",
		children: /* @__PURE__ */ _jsx("feGaussianBlur", {
			stdDeviation: 1,
			in: "SourceGraphic"
		})
	}), /* @__PURE__ */ _jsx("rect", {
		id: "b",
		x: 16,
		width: 280,
		height: 64,
		rx: 4
	})] }), /* @__PURE__ */ _jsxs("g", {
		className: "slide-up",
		transform: "translate(2)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "shadow",
				fill: "#483D9F",
				filter: "url(#a)",
				y: 24,
				width: 280,
				height: 64,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "c",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#b" })
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "#FFF",
				xlinkHref: "#b"
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#c)",
				fill: "#5649BE",
				opacity: .4,
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "translate(16 -4)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 16,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 32,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 48,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 64,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 80,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 96,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 112,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 128,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 144,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 160,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 176,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 192,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 208,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 224,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 240,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 256,
							width: 8,
							height: 8,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 272,
							width: 8,
							height: 8,
							rx: 1
						})
					]
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				fill: "#5649BE",
				mask: "url(#c)",
				opacity: .4,
				children: [/* @__PURE__ */ _jsx("path", { d: "M42.304 28.834c.303.217 1.218.862 2.745 1.935a677.072 677.072 0 0 1 3.509 2.478c.09.063.279.201.57.414.29.213.53.385.722.516.192.131.424.278.697.441.272.163.529.285.77.367.241.081.464.122.67.122h.026c.206 0 .429-.04.67-.122.241-.082.498-.204.77-.367.273-.163.505-.31.697-.441.192-.131.433-.303.723-.516.29-.213.48-.35.569-.414.821-.58 2.91-2.05 6.268-4.413a6.411 6.411 0 0 0 1.634-1.67c.437-.652.656-1.336.656-2.05 0-.598-.212-1.11-.636-1.535-.424-.426-.927-.638-1.507-.638H42.143c-.688 0-1.217.235-1.587.706-.37.47-.556 1.059-.556 1.765 0 .57.246 1.188.737 1.854.49.665 1.013 1.188 1.567 1.568z" }), /* @__PURE__ */ _jsx("path", { d: "M62.66 30.287c-2.928 2.01-5.151 3.57-6.669 4.684-.509.38-.922.677-1.239.89-.317.212-.738.43-1.265.651-.527.222-1.018.333-1.473.333h-.027c-.456 0-.947-.11-1.474-.333-.526-.221-.948-.439-1.265-.651-.317-.213-.73-.51-1.24-.89-1.204-.896-3.423-2.458-6.655-4.684A7.129 7.129 0 0 1 40 29.105v10.782c0 .597.21 1.109.63 1.534.42.426.924.638 1.513.638h19.714c.59 0 1.094-.212 1.514-.638.42-.426.629-.937.629-1.534V29.105c-.384.435-.83.829-1.34 1.182z" })]
			})
		]
	})]
});
export default SvgEmailMarketing;
